import {Component, DestroyRef, inject, Input, OnDestroy, OnInit} from '@angular/core';
import {
  BokkzVpbDataService,
  Buitenlandsebronheffing,
  CorporateTaxEntity,
  VpbAangifte
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormControl, FormGroup} from "@angular/forms";
import {SelectFormControlItem, SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  Observable,
  shareReplay,
  Subscription,
  tap
} from "rxjs";
import {SharedUiButtonModule} from '@snelstart/ui-button';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {CommonModule} from '@angular/common';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-bronheffing',
  templateUrl: './bronheffing.component.html',
  styleUrls: ['./bronheffing.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class BronheffingComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private dataService = inject(BokkzVpbDataService);
  private destroyRef = inject(DestroyRef);
  private bedragSubscriptions = new Subscription();
  public dialogVisible = false;
  public optionsLandcodes: SelectFormControlItem<string>[] = [
    {value: "ALB", label: "Albanië"},
    {value: "ARG", label: "Argentinië"},
    {value: "ARM", label: "Armenië"},
    {value: "ABW", label: "Aruba"},
    {value: "AUS", label: "Australië"},
    {value: "AZE", label: "Azerbeidjan"},
    {value: "BHR", label: "Bahrein"},
    {value: "BGD", label: "Bangladesh"},
    {value: "BRB", label: "Barbedos"},
    {value: "BLR", label: "Belarus (Wit-Rusland)"},
    {value: "BEL", label: "België"},
    {value: "BMU", label: "Bermuda"},
    {value: "BES", label: "Bonaire, St. Eustatius en Saba"},
    {value: "BIH", label: "Bosnië-Herzegovina"},
    {value: "BRA", label: "Brazilië"},
    {value: "BGR", label: "Bulgarije"},
    {value: "CAN", label: "Canada"},
    {value: "CHN", label: "China"},
    {value: "CUW", label: "Curaçao"},
    {value: "CYP", label: "Cyprus"},
    {value: "DNK", label: "Denemarken"},
    {value: "DEU", label: "Duitsland"},
    {value: "EGY", label: "Egypte"},
    {value: "EST", label: "Estland"},
    {value: "PHL", label: "Filippijnen"},
    {value: "FIN", label: "Finland"},
    {value: "FRA", label: "Frankrijk"},
    {value: "GEO", label: "Georgië"},
    {value: "GHA", label: "Ghana"},
    {value: "GRC", label: "Griekenland"},
    {value: "HUN", label: "Hongarije"},
    {value: "HKG", label: "Hongkong"},
    {value: "IRL", label: "Ierland"},
    {value: "ISL", label: "IJsland"},
    {value: "IND", label: "India"},
    {value: "IDN", label: "Indonesië"},
    {value: "ISR", label: "Israël"},
    {value: "ITA", label: "Italië"},
    {value: "JPN", label: "Japan"},
    {value: "JOR", label: "Jordanië"},
    {value: "KAZ", label: "Kazachstan"},
    {value: "KGZ", label: "Kirgizië"},
    {value: "KGZ", label: "Kirgizië"},
    {value: "KWT", label: "Koeweit"},
    {value: "HRV", label: "Kroatië"},
    {value: "LVA", label: "Letland"},
    {value: "LTU", label: "Litouwen"},
    {value: "LUX", label: "Luxemburg"},
    {value: "MKD", label: "Macedonië"},
    {value: "MWI", label: "Malawi"},
    {value: "MYS", label: "Maleisië"},
    {value: "MLT", label: "Malta"},
    {value: "MAR", label: "Marokko"},
    {value: "MEX", label: "Mexico"},
    {value: "MDA", label: "Moldavië"},
    {value: "MNE", label: "Montenegro"},
    {value: "NZL", label: "Nieuw-Zeeland"},
    {value: "NGA", label: "Nigeria"},
    {value: "NOR", label: "Noorwegen"},
    {value: "UKR", label: "Oekraïne"},
    {value: "UZB", label: "Oezbekistan"},
    {value: "OMN", label: "Oman"},
    {value: "AUT", label: "Oostenrijk"},
    {value: "PAK", label: "Pakistan"},
    {value: "PAN", label: "Panama"},
    {value: "POL", label: "Polen"},
    {value: "PRT", label: "Portugal"},
    {value: "QAT", label: "Qatar"},
    {value: "ROU", label: "Roemenië"},
    {value: "RUS", label: "Rusland"},
    {value: "SAU", label: "Saudi-Arabië"},
    {value: "SRB", label: "Servië"},
    {value: "SGP", label: "Singapore"},
    {value: "SXM", label: "Sint Maarten"},
    {value: "SVN", label: "Slovenië"},
    {value: "SVK", label: "Slowakije"},
    {value: "ESP", label: "Spanje"},
    {value: "LKA", label: "Sri Lanka"},
    {value: "SUR", label: "Suriname"},
    {value: "TJK", label: "Tadzjikistan"},
    {value: "TWN", label: "Taiwan"},
    {value: "THA", label: "Thailand"},
    {value: "CZE", label: "Tsjechië"},
    {value: "TUN", label: "Tunesië"},
    {value: "TUR", label: "Turkije"},
    {value: "UGA", label: "Uganda"},
    {value: "VEN", label: "Venezuela"},
    {value: "GBR", label: "Verenigd Koninkrijk"},
    {value: "ARE", label: "Verenigde Arabische Emiraten"},
    {value: "USA", label: "Verenigde Staten van Amerika"},
    {value: "VNM", label: "Vietnam"},
    {value: "ZMB", label: "Zambia"},
    {value: "ZWE", label: "Zimbabwe"},
    {value: "ZAF", label: "Zuid-Afrika"},
    {value: "KOR", label: "Zuid-Korea"},
    {value: "SWE", label: "Zweden"},
    {value: "CHE", label: "Zwitserland"}
  ];

  readonly corporateTaxEntity$: Observable<CorporateTaxEntity> =
    this.dataService.corporateTaxEntity$.pipe(
      filter((data): data is CorporateTaxEntity => !!data?.sstRelationId),
      tap(data => {
        if (data.aangifte) {
          this.updateForm(data.aangifte);
        }
      }),
      takeUntilDestroyed(this.destroyRef),
      shareReplay({bufferSize: 1, refCount: true})
    );

  public bronheffingFg = new FormGroup({
    bronheffingen: new FormArray<
      FormGroup<{
        landcode: FormControl<string | null>;
        brutoDividend: FormControl<number | null>;
        brutoRente: FormControl<number | null>;
        brutoRoyalties: FormControl<number | null>;
        overigeBrutoBerdragen: FormControl<number | null>;
        aftrekbareKosten: FormControl<number | null>;
        verrekenbareBronheffing: FormControl<number | null>;
        voortgewenteldeBronheffingVoorgaandeJaren: FormControl<number | null>;
      }>
    >([]),
  });

  get bronheffingen(): FormArray<FormGroup<{
    landcode: FormControl<string | null>;
    brutoDividend: FormControl<number | null>;
    brutoRente: FormControl<number | null>;
    brutoRoyalties: FormControl<number | null>;
    overigeBrutoBerdragen: FormControl<number | null>;
    aftrekbareKosten: FormControl<number | null>;
    verrekenbareBronheffing: FormControl<number | null>;
    voortgewenteldeBronheffingVoorgaandeJaren: FormControl<number | null>;
  }>> {
    return this.bronheffingFg.controls.bronheffingen;
  }

  addRij(): void {
    this.bronheffingen.push(this.createFormGroup());
    this.watchBedragChanges();
  }

  verwijderRij(index: number): void {
    this.bronheffingen.removeAt(index);
    this.saveForm();
    this.watchBedragChanges();
  }

  createFormGroup(item?: Buitenlandsebronheffing): FormGroup {
    return new FormGroup({
      landcode: new FormControl<string | null>(item?.landcode ?? null),
      brutoDividend: new FormControl<number | null>(item?.brutoDividend ?? null),
      brutoRente: new FormControl<number | null>(item?.brutoRente ?? null),
      brutoRoyalties: new FormControl<number | null>(item?.brutoRoyalties ?? null),
      overigeBrutoBerdragen: new FormControl<number | null>(item?.overigeBrutoBerdragen ?? null),
      aftrekbareKosten: new FormControl<number | null>(item?.aftrekbareKosten ?? null),
      verrekenbareBronheffing: new FormControl<number | null>(item?.verrekenbareBronheffing ?? null),
      voortgewenteldeBronheffingVoorgaandeJaren: new FormControl<number | null>(item?.voortgewenteldeBronheffingVoorgaandeJaren ?? null),
    });
  }

  ngOnInit(): void {
    this.watchBedragChanges();
  }

  ngOnDestroy(): void {
    this.saveForm();
  }

  private watchBedragChanges(): void {
    this.bedragSubscriptions.unsubscribe();
    this.bedragSubscriptions = new Subscription();

    this.bronheffingen.controls.forEach(group => {
      this.bedragSubscriptions.add(
        group.controls.landcode.valueChanges.pipe(
          debounceTime(500),
          distinctUntilChanged(),
          takeUntilDestroyed(this.destroyRef)
        ).subscribe(() => {
          this.saveForm();
        })
      );

      const numericControls = [
        group.controls.brutoDividend,
        group.controls.brutoRente,
        group.controls.brutoRoyalties,
        group.controls.overigeBrutoBerdragen,
        group.controls.aftrekbareKosten,
        group.controls.verrekenbareBronheffing,
        group.controls.voortgewenteldeBronheffingVoorgaandeJaren,
      ];

      numericControls.forEach(control => {
        this.bedragSubscriptions.add(
          control.valueChanges.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            takeUntilDestroyed(this.destroyRef)
          ).subscribe(() => {
            this.saveForm();
            this.dataService.calculateLatestCorporateTaxReturn().subscribe();
          })
        );
      });
    });
  }

  private updateForm(vpbAangifte: VpbAangifte): void {
    const lijst = vpbAangifte.specificatieBronheffingen?.buitenlandsebronheffingen || [];
    const formArray = this.bronheffingFg.get('bronheffingen') as FormArray;

    while (formArray.length > lijst.length) {
      formArray.removeAt(formArray.length - 1, { emitEvent: false });
    }

    for (let i = 0; i < lijst.length; i++) {
      if (i < formArray.length) {
        formArray.at(i).patchValue(lijst[i], { emitEvent: false });
      } else {
        formArray.push(this.createFormGroup(lijst[i]), { emitEvent: false });
      }
    }
  }

  saveForm(): void {
    this.bronheffingFg.updateValueAndValidity({ emitEvent: false });

    const bronheffingen: Buitenlandsebronheffing[] =
      this.bronheffingFg.getRawValue().bronheffingen
        .filter(item =>
          item.landcode !== null ||
          item.brutoDividend !== null ||
          item.brutoRente !== null ||
          item.brutoRoyalties !== null ||
          item.overigeBrutoBerdragen !== null ||
          item.aftrekbareKosten !== null ||
          item.verrekenbareBronheffing !== null ||
          item.voortgewenteldeBronheffingVoorgaandeJaren !== null
        )
        .map(item => ({
          landcode: item.landcode ?? '',
          brutoDividend: item.brutoDividend ?? undefined,
          brutoRente: item.brutoRente ?? undefined,
          brutoRoyalties: item.brutoRoyalties ?? undefined,
          overigeBrutoBerdragen: item.overigeBrutoBerdragen ?? undefined,
          aftrekbareKosten: item.aftrekbareKosten ?? undefined,
          verrekenbareBronheffing: item.verrekenbareBronheffing ?? 0,
          voortgewenteldeBronheffingVoorgaandeJaren: item.voortgewenteldeBronheffingVoorgaandeJaren ?? undefined,
        }));

    this.dataService.patchCorporateTaxEntity(currentEntity => {
      if (!currentEntity.aangifte) {
        return currentEntity;
      }

      return {
        ...currentEntity,
        aangifte: {
          ...currentEntity.aangifte,
          specificatieBronheffingen: {
            ...currentEntity.aangifte.specificatieBronheffingen,
            buitenlandsebronheffingen: bronheffingen,
          },
        },
      } as CorporateTaxEntity;
    });
  }
}
